import { Button, Popover } from "@mui/material";
import React, { CSSProperties, useMemo } from "react";
import { getClasses } from "shared/helpers/styleHelper";

export const ColorPaletteInput = (props: ColorPaletteInputProps) => {
  const { value, options, onChange } = props;

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const selectedPalette = useMemo(() => options.find((option) => option[0] === value) || [], [options, value]);

  return (
    <>
      <Button className="module-color-input-btn" onClick={handleClick} color='secondary'>
        <div className="module-color-half-sqr" style={{ "--color": selectedPalette[0] } as CSSProperties} />
        <div className="module-color-half-sqr" style={{ "--color": selectedPalette[1] } as CSSProperties} />
      </Button>
      <Popover
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        slotProps={{ paper: { className: "module-color-input-popover module-color-palette-input-popover" } }}
      >
        {options.map((option, index) => (
          <div
            key={index}
            className={getClasses({
              "module-color-sqr-row": true,
              "is-selected": value === option[0],
            })}
          >
            {option.map((color, index) => (
              <div
                key={color}
                className={getClasses({
                  "module-color-sqr": true,
                  "is-selected": index ===0 && value === color,
                })}
                style={{ "--color": color } as CSSProperties}
                onClick={() => {
                  onChange(option[0]);
                  handleClose();
                }}
              />
            ))}
          </div>
        ))}
      </Popover>
    </>
  );
};

interface ColorPaletteInputProps {
  value: string;
  options: string[][];
  onChange: (color: string) => void;
}
